import React from "react";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import { useModalTicket } from "../../hooks/useModalTicket";
import { Button } from "../Button";
import { CardInfo } from "../CardInfo";
import { Subtitle } from "../Subtitle";
import "./styles.scss";

interface ComoFuncionaProps {}

function ComoFunciona({}: ComoFuncionaProps) {
  const { handleNavigateToPages, handleAttendance } = useButtonsActions();
  const { toggleModal } = useModalTicket();

  return (
    <section className="comoFunciona" id="comoFunciona">
      <div>
        <Subtitle text="Veja como é simples!" />

        <div className="cardInfoContainer">
          <CardInfo title="Compre em uma das lojas indicadas" step="1">
            <>
              <p>
                Confira a lista de lojas indicadas e escolha onde quer comprar.
              </p>

              <Button
                text="ver lojas indicadas"
                variant="ghost"
                onClick={handleNavigateToPages}
                id="lojasIndicadasComoFunciona"
              />
            </>
          </CardInfo>

          <CardInfo title="Envie o seu boleto à vista para a gente" step="2">
            <>
              <p>Envie seu boleto usando o formulário no final desta página.</p>
              <Button
                text="envie seu boleto"
                variant="ghost"
                onClick={toggleModal}
                id="envieSeuBoletoComoFunciona"
              />
            </>
          </CardInfo>

          <CardInfo title="A Koin parcela o boleto para você" step="3">
            <>
              <p>
                Escolha a quantidade de parcelas que deseja de acordo com a
                proposta enviada.
              </p>
              <Button
                text="Falar com um atendente"
                variant="ghost"
                onClick={handleAttendance}
                id="ligueComoFunciona"
              />
            </>
          </CardInfo>
        </div>

        <div className="infos">
          <p>
            Se o parcelamento for aprovado, enviaremos os boletos para pagamento
            no seu e-mail. A 1ª parcela vence no mesmo dia da aprovação, ta bom?
          </p>
        </div>
      </div>
    </section>
  );
}

export { ComoFunciona };
